/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackConnectionUpdate
 */
export interface SlackConnectionUpdate {
    /**
     * 
     * @type {string}
     * @memberof SlackConnectionUpdate
     */
    name: string;
}

export function SlackConnectionUpdateFromJSON(json: any): SlackConnectionUpdate {
    return SlackConnectionUpdateFromJSONTyped(json, false);
}

export function SlackConnectionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackConnectionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function SlackConnectionUpdateToJSON(value?: SlackConnectionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


